<template>
  <v-footer>
    <footer>
      <div id="sns" class="column">
        <div class="sns">
          <ul>
            <li>
              <span class="snsbutton">
                <!-- twitter -->
                <a
                  href="http://twitter.com/share?&url=http://d-mebius.com/tokyodarkre_ap/&hashtags=tokyodark"
                  onClick="window.open(encodeURI(decodeURI(this.href)), 'tweetwindow', 'width=650, height=470, personalbar=0, toolbar=0, scrollbars=1, sizable=1'); return false;"
                  rel="nofollow"
                >
                  <picture>
                    <souce
                      srcset="../assets/icon_twitter.webp"
                      type="image/webp"
                      width="64"
                      height="64"
                    />
                    <img
                      src="../assets/icon_twitter.png"
                      alt="ツイート"
                      width="64"
                      height="64"
                    />
                  </picture>
                </a>
              </span>
            </li>
            <li>
              <span class="snsbutton">
                <!-- facebook -->
                <a
                  href="http://www.facebook.com/share.php?u=http://d-mebius.com/tokyodarkre_ap/"
                  onclick="window.open(encodeURI(decodeURI(this.href)), 'FBwindow', 'width=554, height=470, menubar=no, toolbar=no, scrollbars=yes'); return false;"
                  rel="nofollow"
                >
                  <picture>
                    <souce
                      srcset="../assets/icon_fb.webp"
                      type="image/webp"
                      width="64"
                      height="64"
                    />
                    <img src="../assets/icon_fb.png" width="64" height="64" />
                  </picture>
                </a>
              </span>
            </li>
          </ul>
          <!-- end .sns -->
        </div>
      </div>
      <div class="copyright">
        <div class="logo">
          <a href="http://d-mebius.com/">
            <picture class="fade">
              <source
                srcset="../assets/logo_mebius.webp"
                type="image/webp"
                width="175"
                height="55"
              />
              <img src="../assets/logo_mebius.png" width="175" height="55" />
            </picture>
          </a>
          <a href="http://www.tokyodark.com/presskit/index.php?l=jp">
            <picture class="fade">
              <source
                srcset="../assets/cherrymochi.webp"
                type="image/webp"
                width="64"
                height="64"
              />
              <img src="../assets/cherrymochi.png" width="64" height="64" />
            </picture>
          </a>
        </div>
        <nav>
          <ul
            class="d-flex flex-row mb-6 bg-surface-variant justify-center"
            style="list-style: none;"
          >
            <li>
              <v-btn
                variant="outlined"
                color="grey-darken-1"
                @click="handleClickChangeLanguage('en')"
                >English</v-btn
              >
            </li>
            <li>
              <v-btn
                variant="outlined"
                color="grey-darken-1"
                @click="handleClickChangeLanguage('ja')"
                >日本語</v-btn
              >
            </li>
          </ul>
        </nav>
        <p>{{ $t("footer.development") }}</p>
        <p>
          &copy;Cherrymochi.All rights reserved.<br />
          Published&Developed by mebius.
        </p>
      </div>
    </footer>
  </v-footer>
</template>

<script>
  import en from "@/assets/i18n/en.json";

  export default {
    name: "LanguageSwitcher",
    methods: {
      handleClickChangeLanguage(lang) {
        this.$i18n.locale = lang;
      },
    },
    created() {
      this.$i18n.setLocaleMessage("en", en);
    },
  };
</script>
